import { useEffect, useRef, useState } from "react";
import { BsWhatsapp } from "react-icons/bs";
import {
  FiCheckCircle,
  FiDownload,
  FiFilter,
  FiMapPin,
  FiPhone,
  FiSearch,
  FiTrendingUp,
  FiUserPlus,
  FiUsers,
} from "react-icons/fi";
import { IoChevronDown } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import default_property from "../../assets-admin/lead-response/default_property.jpg";
import PremiumSubscriptionCard from "../../components/admin/lead-response/PremiumSubscriptionCard";
import ProfileCompletionCard from "../../components/admin/lead-response/ProfileCompletionCard";
import LeadCardSkeleton from "../../components/admin/skeleton-loaders/leads/LeadCardSkeleton";
import NoLeadsScreen from "../../components/admin/skeleton-loaders/leads/NoLeadsScreen";
import api from "../../configs/api";
import { formatPrice, timeAgo } from "../../utils/helpers";
import { showError, showSuccess } from "../../utils/toastUtils";

const leadStatuses = [
  { label: "New", value: "new", color: "text-status-info" },
  { label: "Contacted", value: "contacted", color: "text-status-warning" },
  { label: "Interested", value: "interested", color: "text-primary" },
  {
    label: "Visit Scheduled",
    value: "visit_scheduled",
    color: "text-status-success",
  },
  {
    label: "Not Interested",
    value: "not_interested",
    color: "text-status-danger",
  },
  { label: "Converted", value: "converted", color: "text-status-success" },
];

const statsData = [
  {
    id: 1,
    title: "Today's Leads",
    value: "12",
    link: "View all Leads",
    percentage: "0.29%",
    isPositive: true,
    icon: FiUserPlus,
    iconBg: "#735DFF",
  },
  {
    id: 2,
    title: "Total Lead",
    value: "200",
    link: "complete revenue",
    percentage: "3.45%",
    isPositive: false,
    icon: FiUsers,
    iconBg: "#FF5A29",
  },
  {
    id: 3,
    title: "Active Deals",
    value: "20",
    link: "Total page views",
    percentage: "11.54%",
    isPositive: true,
    icon: FiTrendingUp,
    iconBg: "#0CC763",
  },
  {
    id: 4,
    title: "Deal Closed",
    value: "40",
    link: "Total profit earned",
    percentage: "0.18%",
    isPositive: true,
    icon: FiCheckCircle,
    iconBg: "#0C9CFC",
  },
];

const StatCard = ({
  title,
  value,
  link,
  percentage,
  isPositive,
  icon: Icon,
  iconBg,
}) => (
  <div className="bg-background-card rounded-lg p-4 sm:p-5 shadow-sm">
    <div className="flex justify-between items-start mb-4">
      <div>
        <p className="text-text-primary font-medium text-sm mb-2">{title}</p>
        <h3 className="text-2xl font-semibold text-text-primary">{value}</h3>
      </div>
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center"
        style={{ backgroundColor: iconBg }}
      >
        <Icon className="text-white text-xl size-7" />
      </div>
    </div>
    <div className="flex justify-between items-center">
      <button className="text-text-muted capitalize leading-relaxed underline underline-offset-2 cursor-pointer text-sm hover:text-primary">
        {link}
      </button>
      <span
        className={`text-sm font-semibold ${
          isPositive ? "text-status-success" : "text-status-danger"
        }`}
      >
        {percentage}
      </span>
    </div>
  </div>
);

// Search and Filter Bar Component
const SearchFilterBar = ({
  searchTerm,
  setSearchTerm,
  selectedMonth,
  setSelectedMonth,
  selectedFilter,
  setSelectedFilter,
  onExport,
}) => {
  const months = [
    { label: "All Months", value: "All" },
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
  ];

  const filters = [
    { label: "All Status", value: "All" },
    { label: "New", value: "new" },
    { label: "Contacted", value: "contacted" },
    { label: "Interested", value: "interested" },
    { label: "Visit Scheduled", value: "visit_scheduled" },
    { label: "Not Interested", value: "not_interested" },
    { label: "Converted", value: "converted" },
  ];

  return (
    <div className="sticky top-0 py-4 bg-background shadow-sm z-10">
      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
        {/* Search Input */}
        <div className="flex-1 relative min-w-0">
          <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted" />
          <input
            type="text"
            placeholder="Search by name, phone, email, location..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-primary"
          />
        </div>

        {/* Filters */}
        <div className="flex flex-wrap gap-3 sm:flex-nowrap">
          {/* Month Filter */}
          <div className="relative flex-1 sm:flex-initial">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="appearance-none w-full pl-4 pr-10 py-2.5 border border-gray-300 rounded-lg bg-white text-sm focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-primary cursor-pointer sm:min-w-[140px]"
            >
              {months.map((month) => (
                <option key={month.value} value={month.value}>
                  {month.label}
                </option>
              ))}
            </select>
            <IoChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none" />
          </div>

          {/* Lead Status Filter */}
          <div className="relative flex-1 sm:flex-initial">
            <FiFilter className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none" />
            <select
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.target.value)}
              className="appearance-none w-full pl-9 pr-10 py-2.5 border border-gray-300 rounded-lg bg-white text-sm focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-primary cursor-pointer sm:min-w-[180px]"
            >
              {filters.map((filter) => (
                <option key={filter.value} value={filter.value}>
                  {filter.label}
                </option>
              ))}
            </select>
            <IoChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none" />
          </div>

          {/* Export Button */}
          <button
            onClick={onExport}
            className="flex items-center justify-center gap-2 px-4 py-2.5 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap"
          >
            <FiDownload className="text-text-secondary" />
            <span className="text-sm font-medium text-text-secondary">
              Export
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

const FilterChipsBar = ({
  selectedMonth,
  setSelectedMonth,
  selectedFilter,
  setSelectedFilter,
  searchTerm,
  setSearchTerm,
}) => {
  return (
    <div>
      {/* Active Filters Bar */}
      {(selectedMonth !== "All" ||
        selectedFilter !== "All" ||
        searchTerm.trim() !== "") && (
        <div className="flex flex-wrap items-center gap-2 bg-white shadow-sm border border-gray-200 rounded-md px-4 py-2 mb-4 animate-fadeIn">
          {/* Search Filter */}
          {searchTerm.trim() !== "" && (
            <div className="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">
              <span>Search: {searchTerm}</span>
              <button
                onClick={() => setSearchTerm("")}
                className="text-gray-500 hover:text-gray-800 transition-colors"
              >
                ✕
              </button>
            </div>
          )}

          {/* Month Filter */}
          {selectedMonth !== "All" && (
            <div className="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">
              <span>Month: {selectedMonth}</span>
              <button
                onClick={() => setSelectedMonth("All")}
                className="text-gray-500 hover:text-gray-800 transition-colors"
              >
                ✕
              </button>
            </div>
          )}

          {/* Lead Status Filter */}
          {selectedFilter !== "All" && (
            <div className="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">
              <span>Status: {selectedFilter}</span>
              <button
                onClick={() => setSelectedFilter("All")}
                className="text-gray-500 hover:text-gray-800 transition-colors"
              >
                ✕
              </button>
            </div>
          )}

          {/* Clear All Button */}
          <button
            onClick={() => {
              setSearchTerm("");
              setSelectedMonth("All");
              setSelectedFilter("All");
            }}
            className="ml-auto text-sm font-medium text-primary hover:underline"
          >
            Clear all
          </button>
        </div>
      )}
    </div>
  );
};

const LeadCard = ({ lead }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(lead?.leadStatus || "new");
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [updating, setUpdating] = useState(false);

  const handleSelect = async (value) => {
    setSelectedValue(value);
    setIsOpen(false);

    try {
      setUpdating(true);
      const response = await api.patch(`/leads/status/${lead._id}`, {
        leadStatus: value,
      });

      if (response.data.success) {
        // console.log("Lead status updated:", value);
        showSuccess("Lead status updated");
      }
    } catch (err) {
      console.error("Error updating lead status:", err);
      showError("Status couldn't be updated");
      setSelectedValue(lead?.status || "new");
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formattedLead = {
    name: lead?.leadName || "N/A",
    userId: lead?.userId,
    phone: lead?.phoneNumber || "No phone",
    email: lead?.email || "No email",
    location: lead?.location || "Not Provided",
    leadStatus: lead?.leadStatus,
    searchFor: lead?.searchCriteria?.searchFor || "N/A",
    propertyLocation: lead?.searchCriteria?.propertyLocation || "N/A",
    budget:
      lead?.searchCriteria?.budget?.min && lead?.searchCriteria?.budget?.max
        ? `${formatPrice(lead.searchCriteria.budget.min)} - ${formatPrice(
            lead.searchCriteria.budget.max
          )}`
        : "N/A",
    property: {
      _id: lead?.propertyDetails?._id,
      name: lead?.propertyDetails?.name || "N/A",
      developer: lead?.propertyDetails?.builderOrOwner || "N/A",
      image: lead?.propertyDetails?.thumbnail || default_property,
    },
    date: timeAgo(lead?.createdAt),
  };

  return (
    <div className="bg-white rounded-lg font-poppins shadow-sm border-2 border-gray-200 hover:shadow-md transition-shadow">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          {/* User Profile Section */}
          <div className="flex-shrink-0 flex flex-col items-center p-4 sm:p-3">
            <div className="w-20 h-20 sm:w-16 sm:h-16 lg:w-20 lg:h-20 rounded-full bg-gradient-to-br from-primary to-primary/70 flex items-center justify-center text-white font-bold text-xl">
              {formattedLead.name.charAt(0)}
            </div>
            {/* Action Buttons */}
            <div className="flex sm:flex-col gap-2 mt-4">
              <button className="p-2.5 flex items-center justify-center size-11 rounded-full bg-status-success/10 hover:bg-status-success/20 transition-colors">
                <BsWhatsapp className="text-status-success w-5 h-5 sm:w-full sm:h-full" />
              </button>
              <button className="p-2.5 flex items-center justify-center size-11 rounded-full bg-status-info/10 hover:bg-status-info/20 transition-colors">
                <MdEmail className="text-status-info w-5 h-5 sm:w-full sm:h-full" />
              </button>
              <button className="p-2.5 flex items-center justify-center size-11 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors">
                <FiPhone className="text-primary w-5 h-5 sm:w-full sm:h-full" />
              </button>
            </div>
          </div>

          {/* Details */}
          <div className="flex-1 flex-col divide-y divide-gray-200">
            {/* User Details and Status */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div className="lg:border-r py-4 px-4 lg:px-0 border-primary-navy/10">
                <h2 className="font-medium text-base sm:text-sm lg:text-base">
                  {formattedLead.name}
                </h2>
                <p className="text-xs mt-2 text-text-secondary">
                  ID: {formattedLead.userId}
                </p>
              </div>
              <div className="space-y-2 py-4 px-4 lg:px-0 text-sm">
                <div className="flex items-center gap-2 text-text-secondary">
                  <FiPhone className="flex-shrink-0" />
                  <span className="break-all sm:break-normal">
                    {formattedLead.phone}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-text-secondary">
                  <MdEmail className="flex-shrink-0" />
                  <span className="truncate">{formattedLead.email}</span>
                </div>
                <div className="flex items-center gap-2 text-text-secondary">
                  <FiMapPin className="flex-shrink-0" />
                  <span>{formattedLead.location}</span>
                </div>
              </div>
              {/* Update Status Button */}
              <div className="flex w-full h-full items-end lg:items-end justify-start lg:justify-end p-4">
                <div className="relative w-full lg:w-auto" ref={dropdownRef}>
                  {/* Trigger Button */}
                  <button
                    disabled={updating}
                    onClick={() => setIsOpen(!isOpen)}
                    className={`w-full lg:w-auto flex items-center justify-between gap-3 px-5 py-2.5 border-2 border-primary text-primary rounded-lg bg-white ${
                      updating
                        ? "opacity-70 cursor-not-allowed"
                        : "hover:bg-primary hover:text-white"
                    } transition-all duration-200 font-medium text-sm whitespace-nowrap shadow-sm hover:shadow-md group`}
                  >
                    <span>
                      {leadStatuses.find((s) => s.value === selectedValue)
                        ?.label || "Update Lead Status"}
                    </span>
                    <IoChevronDown
                      className={`transition-transform duration-200 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {/* Dropdown Menu */}
                  {isOpen && (
                    <div className="absolute top-full left-0 lg:left-auto lg:right-0 w-full lg:w-auto mt-2 bg-white border border-border rounded-lg shadow-xl overflow-hidden z-50 lg:min-w-[220px]">
                      {leadStatuses.map((option, index) => (
                        <button
                          key={option.label}
                          onClick={() => handleSelect(option.value)}
                          className={`w-full px-5 py-3 text-left text-sm font-medium transition-all duration-150 hover:bg-gray-50 ${
                            index < leadStatuses.length - 1
                              ? "border-b border-border"
                              : ""
                          } ${option.color || "text-primary"} hover:pl-6`}
                        >
                          <div className="flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-current opacity-70"></span>
                            {option.label}
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Property Details */}
            <div className="text-sm grid grid-cols-1 sm:grid-cols-2 md:grid-cols-8 gap-4 sm:gap-2 py-4 px-4 lg:px-0">
              {/* Search Criteria */}
              <div className="col-span-1 md:col-span-2 flex gap-x-4">
                <div className="h-full border-[3px] rounded-full border-gray-300/50 hidden sm:block"></div>
                <div>
                  <p className="text-text-muted font-medium mb-1">Search For</p>
                  <p className="text-text-primary font-medium">
                    {formattedLead.searchFor}
                  </p>
                </div>
              </div>
              <div className="col-span-1 sm:col-span-1 md:col-span-3 flex gap-x-4">
                <div className="h-full border-[3px] rounded-full border-gray-300/50 hidden sm:block"></div>
                <div>
                  <p className="text-text-muted font-medium mb-1">
                    At the location
                  </p>
                  <p className="text-text-primary font-medium">
                    {formattedLead.propertyLocation}
                  </p>
                </div>
              </div>
              <div className="col-span-1 sm:col-span-2 md:col-span-3 flex gap-x-4">
                <div className="h-full border-[3px] rounded-full border-gray-300/50 hidden sm:block"></div>
                <div>
                  <p className="text-text-muted font-medium mb-1">
                    Budget In between
                  </p>
                  <p className="text-text-primary font-medium">
                    {formattedLead.budget}
                  </p>
                </div>
              </div>
            </div>
            {/* Property Image and Owner */}
            <div className="flex justify-between flex-col gap-2 items-center sm:flex-row">
              <div className="flex gap-3 py-4 px-4 lg:px-0">
                <div className="rounded-md overflow-hidden flex-shrink-0">
                  <img
                    src={formattedLead.property.image}
                    alt={formattedLead.property.name}
                    className="w-20 h-[4.5rem] sm:w-24 sm:h-[4.5rem] object-cover"
                  />
                </div>
                <div className="p-3 sm:p-2 bg-white">
                  <h4
                    onClick={() =>
                      navigate(
                        `/admin/properties/details/${formattedLead?.property?._id}`
                      )
                    }
                    className="font-medium text-text-primary cursor-pointer text-sm mb-1"
                  >
                    {formattedLead.property.name}
                  </h4>
                  <p className="text-xs text-text-muted">
                    {formattedLead.property.developer}
                  </p>
                </div>
              </div>
              <div className="self-end p-2">
                <p className="text-xs tracking-wide text-text-muted">
                  {formattedLead?.date}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LeadResponse = () => {
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeads = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get("/leads/my-listed");
        let fetchedLeads = response?.data?.data;
        // console.log("leads:", response.data);
        setLeads(fetchedLeads);
        setFilteredLeads(fetchedLeads);
      } catch (err) {
        console.error("API fetch error========>", err);
        setError("Failed to fetch leads");
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  //  Combined Filter (Search + Month)
  useEffect(() => {
    let filtered = [...leads];

    // Search filter
    if (searchTerm.trim() !== "") {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter((lead) => {
        return (
          lead.leadName?.toLowerCase().includes(lowerSearch) ||
          lead.email?.toLowerCase().includes(lowerSearch) ||
          lead.phoneNumber?.toLowerCase().includes(lowerSearch) ||
          lead.location?.toLowerCase().includes(lowerSearch) ||
          lead.searchCriteria?.propertyLocation
            ?.toLowerCase()
            .includes(lowerSearch) ||
          lead.searchCriteria?.searchFor?.toLowerCase().includes(lowerSearch)
        );
      });
    }

    //  Month filter
    if (selectedMonth !== "All") {
      filtered = filtered.filter((lead) => {
        if (!lead.createdAt) return false;
        const leadMonth = new Date(lead.createdAt).getMonth();
        const selectedMonthIndex = new Date(
          `${selectedMonth} 1, 2024`
        ).getMonth();
        return leadMonth === selectedMonthIndex;
      });
    }

    // Status filter
    if (selectedFilter !== "All") {
      filtered = filtered.filter((lead) => lead.leadStatus === selectedFilter);
    }

    setFilteredLeads(filtered);
  }, [searchTerm, selectedMonth, selectedFilter, leads]);

  return (
    <div className="min-h-screen font-quicksand bg-background py-3 sm:py-4 md:py-6 pl-3 sm:pl-4 md:pl-6 pr-2 sm:pr-3 md:pr-4">
      <div className="mb-4 cursor-default font-poppins">
        <h1 className="text-2xl font-semibold text-text-primary mb-1">
          Lead / Responses
        </h1>
        <p className="text-text-muted text-sm">Lead / Response</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ">
        {statsData.map((stat) => (
          <StatCard key={stat.id} {...stat} />
        ))}
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
        <div className="xl:col-span-9">
          {/* Pass new props here */}
          <SearchFilterBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          />
          <FilterChipsBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          />

          {error && <p className="text-center text-red-500 py-4">{error}</p>}

          {!error && (
            <div className="space-y-4 scroll-overlay">
              {loading ? (
                Array.from({ length: 3 }).map((_, i) => (
                  <LeadCardSkeleton key={i} />
                ))
              ) : Array.isArray(filteredLeads) && filteredLeads.length > 0 ? (
                filteredLeads.map((lead, index) => (
                  <LeadCard key={lead._id || index} lead={lead} index={index} />
                ))
              ) : filteredLeads.length > 0 ? (
                filteredLeads.map((lead, index) => (
                  <LeadCard key={lead._id || index} lead={lead} index={index} />
                ))
              ) : leads.length === 0 ? (
                <NoLeadsScreen isFiltered={false} />
              ) : (
                <NoLeadsScreen
                  isFiltered={true}
                  onReset={() => {
                    setSearchTerm("");
                    setSelectedMonth("All");
                    setSelectedFilter("All");
                  }}
                />
              )}
            </div>
          )}
        </div>

        <div className="xl:col-span-3 space-y-4 min-h-screen mt-4">
          <div className="xl:sticky xl:top-4 space-y-4">
            <ProfileCompletionCard />
            <PremiumSubscriptionCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadResponse;
